import { youtubeIcon, facebookIcon, xIcon, pinterestIcon, instagramIcon } from './icons';
/**
 *
 * @param {*} brand - Specify the brand for the social media accounts
 * @returns - An array of objects with social media accounts details for the given brand
 * */

var getSocialMediaAccounts = function getSocialMediaAccounts(brand) {
  var mapBrandSocials = {
    argos: {
      hrefYoutube: 'https://www.youtube.com/user/argoscouk',
      hrefFacebook: 'https://www.facebook.com/argos',
      hrefX: 'https://x.com/Argos_online',
      hrefPinterest: 'https://www.pinterest.co.uk/argosonline/',
      hrefInstagram: 'https://www.instagram.com/argos/',
      ariaLabelYoutube: 'Argos YouTube channel',
      ariaLabelFacebook: 'Argos Facebook page',
      ariaLabelX: 'Argos X social network',
      ariaLabelPinterest: 'Argos Pinterest',
      ariaLabelInstagram: 'Argos Instagram'
    },
    tu: {
      hrefYoutube: 'https://www.youtube.com/user/@tuclothing',
      hrefFacebook: 'https://www.facebook.com/tuclothing',
      hrefX: 'https://x.com/tu_clothing',
      hrefPinterest: 'https://www.pinterest.co.uk/tuclothing/',
      hrefInstagram: 'https://www.instagram.com/tuclothing/',
      ariaLabelYoutube: 'Tu YouTube channel',
      ariaLabelFacebook: 'Tu Facebook page',
      ariaLabelX: 'Tu X social network',
      ariaLabelPinterest: 'Tu Pinterest',
      ariaLabelInstagram: 'Tu Instagram'
    },
    habitat: {
      hrefYoutube: 'https://www.youtube.com/user/OfficialHabitat',
      hrefFacebook: 'https://www.facebook.com/HabitatUK',
      hrefX: 'https://x.com/HabitatUK',
      hrefPinterest: 'https://www.pinterest.co.uk/habitatuk/',
      hrefInstagram: 'https://www.instagram.com/habitatuk/',
      ariaLabelYoutube: 'Habitat YouTube channel',
      ariaLabelFacebook: 'Habitat Facebook page',
      ariaLabelX: 'Habitat X social network',
      ariaLabelPinterest: 'Habitat Pinterest',
      ariaLabelInstagram: 'Habitat Instagram'
    }
  };
  var socials = [{
    name: 'youtube',
    dataTest: 'footer-social-logo-youtube',
    href: mapBrandSocials[brand].hrefYoutube,
    target: '_blank',
    icon: youtubeIcon,
    ariaLabel: mapBrandSocials[brand].ariaLabelYoutube
  }, {
    name: 'facebook',
    dataTest: 'footer-social-logo-facebook',
    href: mapBrandSocials[brand].hrefFacebook,
    target: '_blank',
    icon: facebookIcon,
    ariaLabel: mapBrandSocials[brand].ariaLabelFacebook
  }, {
    name: 'x',
    dataTest: 'footer-social-logo-twitter',
    href: mapBrandSocials[brand].hrefX,
    target: '_blank',
    icon: xIcon,
    ariaLabel: mapBrandSocials[brand].ariaLabelX
  }, {
    name: 'pinterest',
    dataTest: 'footer-social-logo-pinterest',
    href: mapBrandSocials[brand].hrefPinterest,
    target: '_blank',
    icon: pinterestIcon,
    ariaLabel: mapBrandSocials[brand].ariaLabelPinterest
  }, {
    name: 'instagram',
    dataTest: 'footer-social-logo-instagram',
    href: mapBrandSocials[brand].hrefInstagram,
    target: '_blank',
    icon: instagramIcon,
    ariaLabel: mapBrandSocials[brand].ariaLabelInstagram
  }];
  return socials.filter(function (social) {
    return social.href;
  });
};

export { getSocialMediaAccounts };